import * as devicedb from '../../../../shared/db/devices-db';

export const fetchDeviceCodes = async (deviceId: string) => {
  return await devicedb.fetchCodes(deviceId)
};
